<script lang="ts">
    import { IFormGroupConfiguration } from '@/components/atoms/form/entities/form-group-configuration.interface';
    import EmailField from "@/components/atoms/form/form-field/EmailField.vue";
    import { FormFieldType } from '@/components/atoms/form/form-field/form-field-type.definition';
    import { IFormGroupState } from '@/components/atoms/form/form-group/form-group-state.interface';
    import { ITranslationData } from 'webshop-modules/translation/translation-data.definition';
    import { Component, Vue, Prop, Emit } from 'vue-facing-decorator';

    @Component({
        components: {
            EmailField,
        },
    })
    export default class FormGroup extends Vue {
        @Prop({ required: true })
        public config!: IFormGroupConfiguration<string>;

        @Prop({ required: true })
        public state!: IFormGroupState;

        @Emit()
        public stateChange(state: IFormGroupState): IFormGroupState {
            return state;
        }

        public readonly FormFieldType: typeof FormFieldType = FormFieldType;

        public noticeList: Map<string, ITranslationData> = new Map();

        public handleStateChange(state: IFormGroupState): void {
            const errors = state.errors ?? {};

            if (state.errors === null) {
                this.noticeList.clear();
                this.stateChange(state);
                return undefined;
            }

            this.noticeList.forEach((msg, key) => {
                if (errors[key]) {
                    this.noticeList.delete(key);
                }
            });

            Object.keys(errors)
                .filter((key) => !this.noticeList.has(key))
                .forEach((key) => {
                    this.noticeList.set(key, errors[key]);
                });

            this.stateChange(state);
        }
    }
</script>

<template>
    <div class="m-formGroup">
        <EmailField
            v-if="config.type === FormFieldType.Email"
            :config="config"
            :state="state"
            @state-change="handleStateChange" />

        <p
            v-for="[key, error] of noticeList"
            v-bind:key="key"
            v-translate="error"
            class="m-formGroup__notice"></p>
    </div>
</template>
